exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "progress[data-v-792b8f42]{display:none}.progress-wrapper[data-v-792b8f42]{background-color:rgba(233,233,233,var(--tw-bg-opacity));display:flex;align-items:center;height:2.5rem;position:relative;text-align:left;text-align:center;width:100%}.progress[data-v-792b8f42],.progress-wrapper[data-v-792b8f42]{--tw-bg-opacity:1;border-radius:.25rem}.progress[data-v-792b8f42]{background-color:rgba(66,66,66,var(--tw-bg-opacity))}", ""]);

// exports
